import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { BllExpandPanelComponent } from './bll-expand-panel.component';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
@Component({
  selector: 'bll-expand',
  template: `<ng-content></ng-content>`,
})
export class BllExpandComponent implements OnInit {
  @Input() multi: boolean = true;
  @Input()
  set noDisabledClass(value: any) {
    const newValue = coerceBooleanProperty(value);

    if (newValue !== this._noDisabledClass) {
      this._noDisabledClass = newValue;
    }
  }
  get noDisabledClass(): any {
    return this._noDisabledClass;
  }
  private _noDisabledClass: boolean;
  panels: BllExpandPanelComponent[] = [];

  constructor() {}

  ngOnInit() {}

  closeOtherPanels(curPanel: BllExpandPanelComponent): void {
    if (this.multi) {
      return;
    }

    this.panels.forEach((panel: BllExpandPanelComponent) => {
      if (panel !== curPanel) {
        panel.isOpen = false;
      }
    });
  }

  currentPanelIndex: number;

  setActivePanel(index: number) {
    const curPanel = this.panels[index];
    if (curPanel) {
      this.currentPanelIndex = index;
      curPanel.isOpen = true;
    }
    this.closeOtherPanels(curPanel);
  }

  addPanel(panel: BllExpandPanelComponent): void {
    this.panels.push(panel);
  }

  removePanel(panel: BllExpandPanelComponent): void {
    const index = this.panels.indexOf(panel);
    if (index !== -1) {
      this.panels.slice(index, 1);
    }
  }
}
